module.exports = window.wp.notices;